export const milesToMeter = (miles) => (miles * 1609.34)